import React from 'react';

interface Props {
  choices: string[];
  correctIndex: number;
  selectedIndex: number | null;
  onSelect: (index: number) => void;
}

export default function ChoiceList({ choices, correctIndex, selectedIndex, onSelect }: Props) {
  return (
    <ul className="choice-list">
      {choices.map((choice, i) => {
        let cls = 'choice-item';
        if (selectedIndex !== null) {
          if (i === correctIndex) cls += ' correct';
          else if (i === selectedIndex) cls += ' wrong';
          else cls += ' disabled';
        }
        return (
          <li
            key={i}
            className={cls}
            onClick={() => selectedIndex === null && onSelect(i)}
          >
            <span className="choice-num">{i + 1}</span>
            <span>{choice}</span>
          </li>
        );
      })}
    </ul>
  );
}
